const Dynamic = resolve => require.ensure([], () => resolve(require('@/views/dynamic/dynamic.vue')), 'Dynamic')

const List = resolve => require.ensure([], () => resolve(require('@/views/dynamic/list/list.vue')), 'List')

const Detail = resolve => require.ensure([], () => resolve(require('@/views/dynamic/detail/detail.vue')), 'Detail')
export default [
    {
        path: '/dynamic',
        name: 'dynamic',
        component: Dynamic,
        redirect: {
            name: 'dynamic-list'
        },
        children: [
            {
                path: '',
                name: 'dynamic-list',
                component: List,
                meta: {
                    title: '消息',
                    icons: 'fa fa-dynamic',
                    name: '动态'
                }
            }, {
                path: 'detail/:id',
                component: Detail,
                name: 'dynamic-detail',
                meta: {
                    title: '消息',
                    icons: 'fa fa-dynamic',
                    name: '动态'
                }
            }
        ]

    }
]